import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createWorkspaceActions } from './actions';
import { WorkspaceActions, WorkspaceState } from './types';

export const useWorkspaceStore = create<WorkspaceState & WorkspaceActions>()(
    immer((set, get, store) => ({
        workspaces: [],
        activeWorkspaces: [],
        pendingWorkspaces: [],
        loading: false,
        switchingWorkspace: false,
        selectedWorkspace: null,
        loadingWorkspace: false,
        error: undefined,
        ...createWorkspaceActions(set, get, store),
    })),
);
